import './image_gallery.js';
import './hamburger_nav.js';
import './scrolltop.js';
import './scroll_trigger.js';
import './maps_link_mobile_desktop.js';

function toggleNavbar(collapseID) {
  document.getElementById(collapseID).classList.toggle("hidden");
  document.getElementById(collapseID).classList.toggle("block");
}
